/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_DescriptionInputs */

const en_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft tips, tutorials and release notes.`)
};

const zh_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft 技巧、教程与版本更新。`)
};

/**
* | output |
* | --- |
* | "PhotoCraft tips, tutorials and release notes." |
*
* @param {Blog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_description = /** @type {((inputs?: Blog_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_description(inputs)
	return zh_blog_description(inputs)
});
export { blog_description as "blog.description" }